import type { SalesContextValue } from "../../../../../sales-context/SalesContext.types";

export interface ShouldUsePreRecordedDisclosuresParams {
    productSku: string;
    features: SalesContextValue["features"];
    taskType: SalesContextValue["taskType"];
    /**
     * Whether the active voice task is a simulated (Expert University / training) task. Training tasks
     * run on the Expert University SDK, whose `startConferenceWithEndpointArn` is a no-op with no live
     * telephony — so the recorded disclosure can never actually play. Never require it in training;
     * the flow uses the standard Continue button instead.
     */
    isSimulatedVoiceTask: boolean;
}

export function shouldUsePreRecordedDisclosures({
    productSku,
    features,
    taskType,
    isSimulatedVoiceTask,
}: ShouldUsePreRecordedDisclosuresParams): boolean {
    // Training/simulated voice tasks have no real telephony to conference the disclosure into, so
    // don't gate Enroll behind it — degrade to Continue (also keeps the Play UI from rendering).
    if (isSimulatedVoiceTask) return false;

    const isFlagEnabledForSku = productSku === "HOMEPRO" && features.isAudioDisclosuresEnabled;
    const isVoiceTask = taskType.isVoice;

    return isFlagEnabledForSku && isVoiceTask;
}
